import AppContainer from 'app/homepage/components/AppContainer';
import { createLandingPageRoute } from 'app/track/utils/TrackUtils';

const routes = {
  '/': createLandingPageRoute('home', {
    doesRequireServerApp: true,
    component: AppContainer,
  }),
  '/features': {
    doesRequireServerApp: true,
    component: AppContainer,
  },
};

export default routes;
